module.exports = __webpack_public_path__ + "static/img/planta.310aab7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/nuestros-comienzos/planta.jpg
// module id = TLci
// module chunks = 0